// Motor del personalizador de lettering (prototipo 2, 6-oct-2026).
// Dibuja la palabra como sale impresa: una base que es el contorno engordado de las
// letras, con su anilla, y las letras en relieve encima. Todo sale de la fuente Aventura.
//
// Medidas reales, sacadas del STL de Sebas (LETTERING/modelos/piezas.json):
//   cuerpo de fuente 30,7 mm · reborde de la base 1,23 mm en el modelo · base 2,67 mm · total 4,75 mm
// Juntado: cada letra se arrima a la anterior hasta que el hueco mínimo entre las dos
// vale HUECO_MM (lo que Sebas hace a mano). Si la palabra pasa de ANCHO_MAX_MM se encoge
// en ancho y alto, nunca en grosor; la anilla va aparte.
(function(){
  const W=1100, H=460;              // lienzo lógico
  const CUERPO_MM=30.7, HUECO_MM=0.4, ANCHO_MAX_MM=90;
  // El contorno NO encoge con la palabra: Sebas lo ensancha en el laminador para que nunca
  // quede ultrafino. En el modelo mide 1,23 mm; en la pieza impresa ronda los 2 mm.
  const REB_MM=2.0;
  const ANILLA_R_MM=5.6, ANILLA_r_MM=2.7;     // a ojo desde las capturas de Rhino: por confirmar
  const PX_MM_MAX=11;               // tope de ampliación, para que una palabra corta no salga gigante
  const MAX_LETRAS=12;

  const hex2rgb=h=>{h=h.replace('#','');return [0,2,4].map(i=>parseInt(h.slice(i,i+2),16));};
  function tono(hex,k){              // k>0 aclara, k<0 oscurece
    const [r,g,b]=hex2rgb(hex), f=v=>Math.round(k>=0 ? v+(255-v)*k : v*(1+k));
    return 'rgb('+f(r)+','+f(g)+','+f(b)+')';
  }
  const lienzo=(w,h)=>{const c=document.createElement('canvas');c.width=w;c.height=h;return c;};
  function tinta(mask,color){
    const c=lienzo(mask.width,mask.height), x=c.getContext('2d');
    x.drawImage(mask,0,0); x.globalCompositeOperation='source-in';
    x.fillStyle=color; x.fillRect(0,0,c.width,c.height); return c;
  }
  // Rellena los huecos cerrados de una máscara: la base es maciza por debajo de las letras.
  function macizar(c){
    const x=c.getContext('2d'), w=c.width, h=c.height, im=x.getImageData(0,0,w,h), d=im.data;
    const fuera=new Uint8Array(w*h), pila=[];
    const mira=i=>{ if(!fuera[i] && d[i*4+3]<128){fuera[i]=1;pila.push(i);} };
    for(let i=0;i<w;i++){mira(i);mira((h-1)*w+i);}
    for(let j=0;j<h;j++){mira(j*w);mira(j*w+w-1);}
    while(pila.length){
      const i=pila.pop(), px=i%w;
      if(px>0)mira(i-1); if(px<w-1)mira(i+1); if(i>=w)mira(i-w); if(i<w*(h-1))mira(i+w);
    }
    for(let i=0;i<w*h;i++) if(!fuera[i] && d[i*4+3]<128){d[i*4]=d[i*4+1]=d[i*4+2]=255;d[i*4+3]=255;}
    x.putImageData(im,0,0);
  }

  // ── Perfil de cada letra: por cada fila, dónde empieza y dónde acaba la tinta.
  //    En unidades de cuerpo (em), con el origen en el punto donde se escribe la letra.
  const MED=160, OX=MED*0.6, OY=MED*1.35, FILAS=MED*2;
  const PERFIL={};
  function perfil(ch){
    if(PERFIL[ch]) return PERFIL[ch];
    const c=lienzo(MED*2.4|0,FILAS), x=c.getContext('2d'); x.font=MED+'px Aventura'; x.fillStyle='#000'; x.fillText(ch,OX,OY);
    const w=c.width, d=x.getImageData(0,0,w,FILAS).data;
    const izq=new Float32Array(FILAS).fill(1e6), der=new Float32Array(FILAS).fill(-1e6);
    let arriba=FILAS, abajo=-1;
    for(let y=0;y<FILAS;y++) for(let px=0;px<w;px++) if(d[(y*w+px)*4+3]>110){
      const e=(px-OX)/MED; if(e<izq[y])izq[y]=e; if(e>der[y])der[y]=e;
      if(y<arriba)arriba=y; if(y>abajo)abajo=y;
    }
    return PERFIL[ch]={izq,der,vacio:abajo<0,arriba:(arriba-OY)/MED,abajo:(abajo-OY)/MED};
  }

  // Coloca las letras juntándolas. Devuelve la posición de cada una y la caja de la tinta, en em.
  function componer(letras){
    const hueco=HUECO_MM/CUERPO_MM;
    const ant=new Float32Array(FILAS).fill(-1e6);      // borde derecho de lo ya puesto, fila a fila
    const pos=[]; let x0=1e6,x1=-1e6,y0=1e6,y1=-1e6, primera=true;
    for(const ch of letras){
      const p=perfil(ch); if(p.vacio){pos.push(null);continue;}
      let dx=0;
      if(!primera){
        let libre=1e6, tope=-1e6;
        for(let y=0;y<FILAS;y++){ if(ant[y]>tope)tope=ant[y]; if(p.izq[y]<1e5 && ant[y]>-1e5){const g=p.izq[y]-ant[y]; if(g<libre)libre=g;} }
        dx = libre<1e5 ? hueco-libre : tope+hueco;     // sin filas en común (un punto, una tilde): pegada al tope
      }
      for(let y=0;y<FILAS;y++) if(p.der[y]>-1e5){
        const d=p.der[y]+dx, i=p.izq[y]+dx; if(d>ant[y])ant[y]=d; if(i<x0)x0=i; if(d>x1)x1=d;
      }
      if(p.arriba<y0)y0=p.arriba; if(p.abajo>y1)y1=p.abajo;
      pos.push(dx); primera=false;
    }
    return {pos,x0,x1,y0,y1};
  }

  function dibujar(cv,o){
    const dpr=Math.min(window.devicePixelRatio||1,2);
    const w=Math.round(W*dpr), h=Math.round(H*dpr);
    if(cv.width!==w||cv.height!==h){cv.width=w;cv.height=h;}
    const ctx=cv.getContext('2d'); ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,w,h);
    // o.glifos: una entrada por letra, ya con la forma alternativa elegida (ver variantes.json)
    const letras=(o.glifos || [...(o.texto||'').replace(/\s+/g,'')]).slice(0,MAX_LETRAS);
    if(!letras.length) return {vacio:true};
    const base=o.base, top=o.unColor ? o.base : o.top;

    // 1 · colocación y tamaño real
    const c=componer(letras);
    if(c.x1<c.x0) return {vacio:true};
    const tintaNat=(c.x1-c.x0)*CUERPO_MM;                          // mm de letras a tamaño natural
    const k=Math.min(1,(ANCHO_MAX_MM-2*REB_MM)/tintaNat);          // lo que encogen las letras para caber
    const cuerpo=CUERPO_MM*k, reb_mm=REB_MM;                       // el contorno se queda como está
    const ancho_mm=tintaNat*k+2*reb_mm, alto_mm=(c.y1-c.y0)*cuerpo+2*reb_mm;
    const total_mm=ancho_mm+ANILLA_R_MM*1.5;

    // 2 · de milímetros a píxeles
    const pxmm=Math.min(PX_MM_MAX,(W-70)/total_mm,(H-70)/alto_mm)*dpr;
    const S=cuerpo*pxmm, reb=reb_mm*pxmm, R=ANILLA_R_MM*pxmm, r=ANILLA_r_MM*pxmm;
    const X0=(w-total_mm*pxmm)/2 + ANILLA_R_MM*1.5*pxmm + reb - c.x0*S;   // origen de escritura
    const Y0=(h-alto_mm*pxmm)/2 + reb - c.y0*S;                            // línea base

    // 3 · máscaras: A = letras, B = base
    const A=lienzo(w,h), a=A.getContext('2d'); a.font=S+'px Aventura'; a.fillStyle='#fff';
    const B=lienzo(w,h), b=B.getContext('2d'); b.font=S+'px Aventura'; b.fillStyle=b.strokeStyle='#fff';
    b.lineJoin='round'; b.lineCap='round'; b.lineWidth=reb*2;
    letras.forEach((ch,i)=>{ if(c.pos[i]===null) return; const x=X0+c.pos[i]*S;
      a.fillText(ch,x,Y0); b.strokeText(ch,x,Y0); b.fillText(ch,x,Y0); });

    // anilla: abajo a la izquierda si la primera es alta (mayúscula, número…), arriba si es minúscula baja
    const p0=perfil(letras[0]), alta=p0.arriba < -0.62;
    const f0=Math.round(OY+(alta ? -0.10 : p0.arriba+0.12)*MED);          // fila donde se agarra
    let borde=1e6; for(let y=Math.max(0,f0-10);y<=Math.min(FILAS-1,f0+10);y++) if(p0.izq[y]<borde)borde=p0.izq[y];
    if(borde>1e5) borde=c.x0;
    const ax=X0+(borde+c.pos[0])*S-reb-R*0.55, ay=Y0+(f0-OY)/MED*S+(alta? -R*0.15 : R*0.1);
    b.beginPath(); b.arc(ax,ay,R,0,Math.PI*2); b.fill();
    macizar(B);
    b.globalCompositeOperation='destination-out';
    b.beginPath(); b.arc(ax,ay,r,0,Math.PI*2); b.fill();
    b.globalCompositeOperation='source-over';

    // 4 · composición con volumen
    const kx=0.72, ky=1;
    const gb=Math.max(2,Math.round(0.45*pxmm));     // canto visible de la base
    const ga=Math.max(2,Math.round(0.8*pxmm));     // relieve visible de las letras
    const th=alto_mm*pxmm, tw=ancho_mm*pxmm, yT=Y0+c.y0*S;

    ctx.save();
    ctx.shadowColor='rgba(40,25,10,0.28)'; ctx.shadowBlur=2.2*pxmm; ctx.shadowOffsetX=0.7*pxmm; ctx.shadowOffsetY=1.4*pxmm;
    ctx.drawImage(tinta(B,tono(base,-0.3)),gb*kx,gb*ky);
    ctx.restore();
    const Bcanto=tinta(B,tono(base,-0.28));
    for(let i=gb;i>=1;i--) ctx.drawImage(Bcanto,i*kx,i*ky);
    const cara=lienzo(w,h), cc=cara.getContext('2d');
    cc.drawImage(tinta(B,'#'+base.replace('#','')),0,0);
    cc.globalCompositeOperation='source-atop';
    let g=cc.createLinearGradient(0,yT-reb,0,yT+th);
    g.addColorStop(0,'rgba(255,255,255,0.16)'); g.addColorStop(1,'rgba(0,0,0,0.05)');
    cc.fillStyle=g; cc.fillRect(0,0,w,h);
    cc.shadowColor='rgba(0,0,0,0.22)'; cc.shadowBlur=0.7*pxmm; cc.shadowOffsetX=ga*kx*0.5+0.35*pxmm; cc.shadowOffsetY=ga*ky*0.5+0.5*pxmm;
    cc.drawImage(tinta(A,'rgba(0,0,0,0.9)'),0,0);
    ctx.drawImage(cara,0,0);

    // Letras en RELIEVE: la cara queda arriba a la izquierda y la pared se ve abajo a la
    // derecha, que es hacia donde cae la sombra. Al revés se lee como un hundido.
    const ox=-ga*kx/2, oy=-ga*ky/2;
    const Apared=tinta(A,tono(top,-0.30));
    for(let i=ga;i>=1;i--) ctx.drawImage(Apared,ox+i*kx,oy+i*ky);
    const bisel=Math.max(1,0.14*pxmm);
    ctx.drawImage(tinta(A,tono(top,0.38)),ox-bisel*kx,oy-bisel*ky);      // filo de luz del canto redondeado
    const caraA=lienzo(w,h), ca=caraA.getContext('2d');
    ca.drawImage(tinta(A,'#'+top.replace('#','')),0,0);
    ca.globalCompositeOperation='source-atop';
    g=ca.createLinearGradient(X0,yT,X0+tw*0.2,yT+th);
    g.addColorStop(0,'rgba(255,255,255,0.12)'); g.addColorStop(0.55,'rgba(255,255,255,0.02)'); g.addColorStop(1,'rgba(0,0,0,0.05)');
    ca.fillStyle=g; ca.fillRect(0,0,w,h);
    ctx.drawImage(caraA,ox,oy);

    return {vacio:false, letras:letras.length, ancho_mm, alto_mm, escala:k, alto_letra_mm:cuerpo*0.8};
  }

  window.Lettering={dibujar, W, H, MAX_LETRAS, ANCHO_MAX_MM};
})();
